export {};
// export type CompleteColorDefinition = { color: string; opacity: number; hsla: string };
// export type CompleteStrokeDefinition = CompleteColorDefinition & {
// 	dash?: number[];
// 	width?: number;
// };
// export const parseColor = (definition: ColorDefinition): CompleteColorDefinition | undefined => {
// 	if (definition && definition.color) {
// 		const color = tinycolor(definition.color);
// 		let alpha = definition.opacity !== undefined ? definition.opacity : color.getAlpha();
// 		color.setAlpha(1);
// 		const hsl = color.toHslString();
// 		color.setAlpha(alpha);
// 		const hsla = color.toHslString();
// 		return { color: hsl, opacity: alpha, hsla };
// 	} else {
// 		return undefined;
// 	}
// };
